var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var ReceiptLayout = /** @class */ (function () {
    function ReceiptLayout(props) {
        this.blockLines = [];
        Object.assign(this, props);
        this.blockLines.push(new BlockBarCode(Align.Center, BarCodeType.QRCode));
        this.blockLines.push(new BlockBarCode(Align.Center, BarCodeType.QRCode));
    }
    return ReceiptLayout;
}());
export { ReceiptLayout };
var Block = /** @class */ (function () {
    function Block(align) {
        this.align = align;
    }
    return Block;
}());
var BlockText = /** @class */ (function (_super) {
    __extends(BlockText, _super);
    function BlockText(props) {
        var _this = _super.call(this, props.align) || this;
        // Object.assign(this, props)
        _this.fontSize = props.fonSize;
        _this.text = props.text;
        return _this;
    }
    return BlockText;
}(Block));
export { BlockText };
var Separator = /** @class */ (function (_super) {
    __extends(Separator, _super);
    function Separator(value) {
        var _this = _super.call(this, Align.Center) || this;
        if (value.length > 1 || value.length === 0) {
            throw new Error('only one character');
        }
        return _this;
    }
    return Separator;
}(Block));
export { Separator };
var BlockBarCode = /** @class */ (function (_super) {
    __extends(BlockBarCode, _super);
    function BlockBarCode(align, type) {
        var _this = _super.call(this, align) || this;
        _this.type = type;
        return _this;
    }
    return BlockBarCode;
}(Block));
export { BlockBarCode };
export var Align;
(function (Align) {
    Align["Left"] = "left";
    Align["Center"] = "center";
    Align["Right"] = "right";
})(Align || (Align = {}));
export var widthPaper = 80;
export var FontSize;
(function (FontSize) {
    FontSize[FontSize["smaller"] = widthPaper === 80 ? 10 : 7] = "smaller";
    FontSize[FontSize["small"] = widthPaper === 80 ? 12 : 8] = "small";
    FontSize[FontSize["normal"] = widthPaper === 80 ? 15 : 10] = "normal";
    FontSize[FontSize["big"] = widthPaper === 80 ? 25 : 22] = "big";
    FontSize[FontSize["bigger"] = widthPaper === 80 ? 27 : 25] = "bigger";
    FontSize[FontSize["biggest"] = widthPaper === 80 ? 29 : 27] = "biggest";
    FontSize[FontSize["extraBiggest"] = widthPaper === 80 ? 31 : 29] = "extraBiggest";
})(FontSize || (FontSize = {}));
export var FontAtt;
(function (FontAtt) {
    FontAtt["Normal"] = "normal";
    FontAtt["Bold"] = "bold";
    FontAtt["Cursiva"] = "cursiva";
})(FontAtt || (FontAtt = {}));
export var BarCodeType;
(function (BarCodeType) {
    BarCodeType["QRCode"] = "qrCode";
    BarCodeType["Code_128"] = "code128";
    BarCodeType["Code_39"] = "code39";
})(BarCodeType || (BarCodeType = {}));
export var Placeholders;
(function (Placeholders) {
    Placeholders["firstName"] = "${firstName}";
    Placeholders["lastName"] = "${lastName}";
    Placeholders["staffId"] = "${staffId}";
    Placeholders["date"] = "${date}";
    Placeholders["time"] = "${time}";
    Placeholders["waypoint"] = "${waypoint}";
    Placeholders["validUntil"] = "${validUntil}";
    Placeholders["validFor"] = "${validFor}";
    Placeholders["eventDate"] = "${eventDate}";
    Placeholders["eventTime"] = "${eventTime}";
    Placeholders["account"] = "${account}";
    Placeholders["ticketNumber"] = "${ticketNumber}";
    Placeholders["receiptNumber"] = "${receiptNumber}";
})(Placeholders || (Placeholders = {}));



//////////////////
// WEBPACK FOOTER
// ./src/modules/ReceiptLayouts/Model.ts
// module id = 45
// module chunks = 0